// Link to your Express server
const apiUrl = new URL(window.location.origin);
apiUrl.pathname = "/api";

export const BACKEND_URL = apiUrl.toString();
console.debug("Setting API ", BACKEND_URL);

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const isProd = import.meta.env.PROD;

export const isDev = import.meta.env.DEV;

export const mode = import.meta.env.MODE;

console.debug("Running in mode:", mode);
